var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 8.00071C3.33198 7.82539 3.3665 7.65177 3.43362 7.48981C3.50074 7.32784 3.59914 7.18071 3.72318 7.05685L10.3866 0.391102C10.637 0.140683 10.9765 -5.27717e-09 11.3305 0C11.6845 5.27717e-09 12.0241 0.140683 12.2744 0.391102C12.5247 0.64152 12.6654 0.981159 12.6654 1.3353C12.6654 1.68945 12.5247 2.02909 12.2744 2.27951L6.55515 8.00071L12.2724 13.7199C12.5228 13.9703 12.6635 14.31 12.6636 14.6642C12.6637 15.0184 12.5231 15.3582 12.2727 15.6087C12.0224 15.8592 11.6828 15.9999 11.3288 16C10.9747 16.0001 10.6351 15.8594 10.3846 15.609L3.72118 8.94325C3.47172 8.69308 3.33175 8.35407 3.33203 8.00071Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.da215ed8551cf5de836a32c79bb5fa4d.svg";
export { ForwardRef as ReactComponent };